var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Mutation, State } from 'vuex-simple';
var AppModule = /** @class */ (function () {
    function AppModule() {
        this.version = '1.0.0';
        this.sideNavigationVisible = false;
        this.fluid = false;
        this.snackbar = {
            visible: false,
            text: '',
            color: 'secondary',
            // time in milliseconds
            timeout: 6000,
        };
        this.contentSize = {
            x: 0,
            y: 0,
        };
    }
    AppModule.prototype.openSideNavigation = function () {
        this.sideNavigationVisible = true;
    };
    AppModule.prototype.closeSideNavigation = function () {
        this.sideNavigationVisible = false;
    };
    AppModule.prototype.toggleFluidLayout = function () {
        this.fluid = !this.fluid;
    };
    AppModule.prototype.showSnackbar = function (payload) {
        this.snackbar.visible = true;
        this.snackbar.text = payload.text;
        this.snackbar.color = payload.color;
    };
    AppModule.prototype.setSnackbarTimeout = function (payload) {
        this.snackbar.timeout = payload.timeout;
    };
    AppModule.prototype.hideSnackbar = function () {
        this.snackbar.visible = false;
        this.snackbar.text = '';
        this.snackbar.color = 'secondary';
    };
    AppModule.prototype.setContentSize = function (payload) {
        this.contentSize.x = payload.x;
        this.contentSize.y = payload.y;
    };
    __decorate([
        State(),
        __metadata("design:type", String)
    ], AppModule.prototype, "version", void 0);
    __decorate([
        State(),
        __metadata("design:type", Boolean)
    ], AppModule.prototype, "sideNavigationVisible", void 0);
    __decorate([
        State(),
        __metadata("design:type", Boolean)
    ], AppModule.prototype, "fluid", void 0);
    __decorate([
        State(),
        __metadata("design:type", Object)
    ], AppModule.prototype, "contentSize", void 0);
    __decorate([
        State(),
        __metadata("design:type", Object)
    ], AppModule.prototype, "snackbar", void 0);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AppModule.prototype, "openSideNavigation", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AppModule.prototype, "closeSideNavigation", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AppModule.prototype, "toggleFluidLayout", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AppModule.prototype, "showSnackbar", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AppModule.prototype, "setSnackbarTimeout", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AppModule.prototype, "hideSnackbar", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AppModule.prototype, "setContentSize", null);
    return AppModule;
}());
export { AppModule };
